import React from 'react'

export const Title = ({content}) => {
  return (
    <h1>{content}</h1>
  )
}
